/* eslint-disable react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import {
  ROUTE_MARKETING_PAGE,
  ROUTE_USER_PROFILE_PAGE,
  ROUTE_SSO,
  ROUTE_INSTITUTION_ADMIN,
  ROUTE_CREATE_COURSE_PAGE,
  ROUTE_CERTIFICATE_VERIFICATION_PAGE,
  ROUTE_COURSE_CERTIFICATION,
  ROUTE_ACCOUNTS_SETTINGS,
  ROUTE_ACCOUNTS_SUBSCRIPTIONS,
  ROUTE_COURSE_ADMIN,
  ROUTE_CONTACT_PAGE,
  ROUTE_ACCOUNTS_NOTIFICATIONS,
  ROUTE_PAYMENT_DETAILS_PAGE,
  ROUTE_PAYMENT_UPDATE_PAYMENT_METHOD_PAGE,
  ROUTE_PAYMENT_THANKYOU_PAGE,
  ROUTE_ACCOUNTS_LOGIN,
  ROUTE_COURSE_COHORT_ENDED,
  ROUTE_PARTNERS_LISTING_PAGE,
  ROUTE_COURSES,
  ROUTE_HOMEPAGE,
  ROUTE_COHORT_ADMIN,
  ROUTE_CREATE_INSTITUTION_PAGE,
} from '../../../ReduxStorage/routeActions';
import { LoadableMarketingPages } from '../MarketingPages/loadable';
import { LoadableProfilePage } from '../ProfilePage/loadable';
import { WasabiPages } from '../WasabiPage/constants';
import { LoadableWasabiPage } from '../WasabiPage/loadable';
import { LoadableSSOPage } from '../SSOPage/loadable';
import { LoadableInstitutionSettings } from '../InstitutionSettings/loadable';
import { LoadableSubscribeModals } from '../SubscribeModals/loadable';
import { CourseAlertBanners } from '../CourseAlertBanners/mountable';
import { MountableCohortSwitcher } from '../CourseBar/CohortSwitchingMenu/mountable';
import { MountableKarma } from '../CourseBar/Karma/mountable';
import { LoadableCertificateVerification } from '../CertificateVerification/loadable';
import { MountableCourseCertificationPage } from '../Certification/mountable';
import { ConnectedLoadableLinkedNotification } from '../LinkedNotification/connector';
import { PageFooter } from './PageFooter';
import { LoadableCreateCoursePage } from '../CreateCoursePage/loadable';
import { LoadableAccountsSettingsPage } from '../Accounts/Settings/loadable';
import { LoadableSubscriptionsAdmin } from '../SubscriptionsAdmin/loadable';
import { MountableUserTimezoneCheck } from '../../components/UserTimezoneCheck/mountable';
import { PortalSkipLinks } from '../SkipLinks/portal';
import { CourseProgressBarPortal } from '../../CourseProgressBar/loadable';
import { ProfileLinkPortal } from '../CourseBar/LoadableProfileLink';
import { BadgeCertificateContainerPortal } from '../CourseBar/BadgeCertificateContainer';
import { LoadableContactPage } from '../ContactPage/Loadable';
import { LoadableAccountsNotificationsPage } from '../Accounts/Notifications/loadable';
import { LoadablePaymentDetailsPage } from '../PaymentPage/LoadablePaymentDetailsPage';
import { LoadableUpdatePaymentMethodPage } from '../PaymentPage/LoadableUpdatePaymentMethodPage';
import { LoadableThankYouPage } from '../ThankYouPage/LoadableThankYouPage';
import { LoadableAccountsLoginPage } from '../Accounts/LoginPage/loadable';
import { LoadableCohortEndedPage } from '../CohortEndedPage/loadable';
import { LoadablePartnersListingPage } from '../PartnersListingPage/loadable';
import { LoadableCoursesPage } from '../CoursesPage/loadable';
import { LoadableHomepage } from '../HomePage/loadable';
import { LoadableCourseAdmin } from '../CourseAdmin/CourseAdmin/loadable';
import { LoadableCohortAdmin } from '../CohortAdmin/loadable';
import { ConnectedUserpilot } from '../Userpilot/connector';
import { ConnectedCreateInstitutionPage } from '../CreateInstitutionPage/connector';
import { LoadableLearnersConsentModal } from '../LearnersConsentModal/loadable';
import { ConnectedFaceCheck } from '../IdentitySession/FaceCheck/connector';
import { LinkProvider } from '../../components/Contexts/LinkContext';
import { Link } from '../Link';
import { ConnectedTosSnackbar } from '../../components/TosSnackbar/connector';

export class BasePage extends React.Component {
  static propTypes = {
    type: PropTypes.string,
  };

  renderPage = () => {
    const { type } = this.props;

    if (WasabiPages.includes(type)) {
      return <LoadableWasabiPage type={type} />;
    }

    switch (type) {
      case ROUTE_CREATE_INSTITUTION_PAGE: {
        return <ConnectedCreateInstitutionPage />;
      }
      case ROUTE_SSO: {
        return <LoadableSSOPage />;
      }
      case ROUTE_INSTITUTION_ADMIN: {
        return <LoadableInstitutionSettings />;
      }
      case ROUTE_CREATE_COURSE_PAGE: {
        return <LoadableCreateCoursePage />;
      }
      case ROUTE_CERTIFICATE_VERIFICATION_PAGE: {
        return <LoadableCertificateVerification />;
      }
      case ROUTE_MARKETING_PAGE: {
        return <LoadableMarketingPages />;
      }
      case ROUTE_USER_PROFILE_PAGE: {
        return <LoadableProfilePage />;
      }
      case ROUTE_COURSE_CERTIFICATION: {
        return <MountableCourseCertificationPage />;
      }
      case ROUTE_ACCOUNTS_SETTINGS: {
        return <LoadableAccountsSettingsPage />;
      }
      case ROUTE_ACCOUNTS_SUBSCRIPTIONS: {
        return <LoadableSubscriptionsAdmin />;
      }
      case ROUTE_ACCOUNTS_NOTIFICATIONS: {
        return <LoadableAccountsNotificationsPage />;
      }
      case ROUTE_CONTACT_PAGE: {
        return <LoadableContactPage />;
      }
      case ROUTE_COURSE_ADMIN: {
        return <LoadableCourseAdmin />;
      }
      case ROUTE_PAYMENT_DETAILS_PAGE: {
        return <LoadablePaymentDetailsPage />;
      }
      case ROUTE_PAYMENT_UPDATE_PAYMENT_METHOD_PAGE: {
        return <LoadableUpdatePaymentMethodPage />;
      }
      case ROUTE_PAYMENT_THANKYOU_PAGE: {
        return <LoadableThankYouPage />;
      }
      case ROUTE_ACCOUNTS_LOGIN: {
        return <LoadableAccountsLoginPage />;
      }
      case ROUTE_COURSE_COHORT_ENDED: {
        return <LoadableCohortEndedPage />;
      }
      case ROUTE_COHORT_ADMIN: {
        return <LoadableCohortAdmin />;
      }
      case ROUTE_PARTNERS_LISTING_PAGE: {
        return <LoadablePartnersListingPage />;
      }
      case ROUTE_COURSES: {
        return <LoadableCoursesPage />;
      }
      case ROUTE_HOMEPAGE: {
        return <LoadableHomepage />;
      }
      default: {
        return null;
      }
    }
  };

  renderUserTimezoneChecker = () => {
    const { type } = this.props;

    if (type === ROUTE_ACCOUNTS_SETTINGS || !window.OpenLearningUserData) {
      return null;
    }

    const { timezone, timezoneOffset } = window.OpenLearningUserData;
    return (
      <MountableUserTimezoneCheck
        previousTimezone={timezone}
        previousTimezoneOffset={timezoneOffset}
      />
    );
  };

  render() {
    return (
      <LinkProvider value={Link}>
        <PortalSkipLinks />
        {this.renderPage()}
        {this.renderUserTimezoneChecker()}
        <CourseAlertBanners />
        <MountableKarma />
        <MountableCohortSwitcher />
        <BadgeCertificateContainerPortal />
        <CourseProgressBarPortal />
        <ProfileLinkPortal />
        <LoadableSubscribeModals />
        <ConnectedLoadableLinkedNotification />
        <LoadableLearnersConsentModal />
        <PageFooter />
        <ConnectedUserpilot />
        <ConnectedFaceCheck />
        <ConnectedTosSnackbar />
      </LinkProvider>
    );
  }
}
